<script>
import PostsTable from '@/components/boards/PostsTable';

export default {
    page: {
        title: 'Posts'
    },

    extends: PostsTable,

    data() {
        return {
            includeHeader: true,
            pageTitle: 'Posts'
        };
    },

    computed: {
        options() {
            return { addButton: false };
        }
    },

    created() {
        this.labels.push({
            value: 'board.name',
            text: 'Board',
            width: '150px'
        });
    }
};
</script>
